class TabList extends HTMLElement {
  constructor() {
    super();
    this.tablist = this.querySelector('[role="tablist"]');
    this.tabs = this.querySelectorAll('[role="tab"]');
    this.panels = this.querySelectorAll('[role="tabpanel"]');
    this.tablistOrientation = this.tablist.getAttribute('aria-orientation');
    this.tabs.forEach((tab) => {
      tab.addEventListener('click', (event) => {
        this.selectTab(event.currentTarget);
      });
    });

    this.tabs.forEach((tab) => {
      tab.addEventListener('keydown', this.handleKeydown.bind(this));
    });
    console.log('tablist active');
  }

  selectTab(selectedTab) {
    this.tabs.forEach((tab) => {
      tab.setAttribute('aria-selected', 'false');
      tab.setAttribute('tabindex', '-1');
    });

    selectedTab.setAttribute('aria-selected', 'true');
    selectedTab.setAttribute('tabindex', '0');
    selectedTab.focus();

    this.panels.forEach((panel) => {
      panel.setAttribute('hidden', '');
      panel.setAttribute('tabindex', '-1');
    });

    const selectedPanel = this.querySelector(`#${selectedTab.getAttribute('aria-controls')}`);

    selectedPanel.removeAttribute('hidden');
    selectedPanel.setAttribute('tabindex', '0');
  }

  handleKeydown(event) {
    const index = Array.prototype.indexOf.call(this.tabs, event.currentTarget);
    const length = this.tabs.length;

    if ((this.tablistOrientation === 'horizontal' && event.key === 'ArrowRight') || (this.tablistOrientation === 'vertical' && event.key === 'ArrowDown')) {
      event.preventDefault();
      if (index === length - 1) {
        this.selectTab(this.tabs[0]);
      } else {
        this.selectTab(this.tabs[index + 1]);
      }
    } else if ((this.tablistOrientation === 'horizontal' && event.key === 'ArrowLeft') || (this.tablistOrientation === 'vertical' && event.key === 'ArrowUp')) {
      event.preventDefault();
      if (index === 0) {
        this.selectTab(this.tabs[length - 1]);
      } else {
        this.selectTab(this.tabs[index - 1]);
      }
    }
  }
}

customElements.get('tab-list') || customElements.define('tab-list', TabList);
